import { Header } from "@/components/landing/Header";
import { KineticHero } from "@/components/landing/KineticHero";
import { Manifesto } from "@/components/landing/Manifesto";
import { DroneVideo } from "@/components/landing/DroneVideo";
import { Apartments } from "@/components/landing/Apartments";
import { Gallery } from "@/components/landing/Gallery";
import { LocationSection } from "@/components/landing/LocationSection";
import { ContactSection } from "@/components/landing/ContactSection";
import { Footer } from "@/components/landing/Footer";
import { CookieBanner, MobileBottomSpacer } from "@/components/landing/CookieBanner";
import { WhatsAppButton } from "@/components/landing/WhatsAppButton";
import { MobileActionBar } from "@/components/landing/MobileActionBar";
import { BrochureModal } from "@/components/landing/BrochureModal";

export default function LandingPage() {
  return (
    <div className="bg-ivory font-sans text-ink" data-testid="landing-page">
      <div className="noise-overlay" />
      <Header />
      <main>
        <KineticHero />
        <Manifesto />
        <DroneVideo />
        <Apartments />
        <Gallery />
        <LocationSection />
        <ContactSection />
      </main>
      <Footer />
      <MobileBottomSpacer />
      <CookieBanner />
      <WhatsAppButton />
      <MobileActionBar />
      <BrochureModal />
    </div>
  );
}
